var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.214 25C27.752 25 29 23.8 29 22.321V15.18c0-1.48-1.248-2.679-2.786-2.679h-4.643V8.929c0-1.97 1.666-3.572 3.715-3.572h.464c.772 0 1.393-.597 1.393-1.34V1.34C27.143.597 26.522 0 25.75 0h-.464C20.156 0 16 3.996 16 8.929V22.32C16 23.801 17.248 25 18.786 25h7.428zm-16 0C11.752 25 13 23.8 13 22.321V15.18c0-1.48-1.248-2.679-2.786-2.679H5.571V8.929c0-1.97 1.666-3.572 3.715-3.572h.464c.772 0 1.393-.597 1.393-1.34V1.34C11.143.597 10.522 0 9.75 0h-.464C4.156 0 0 3.996 0 8.929V22.32C0 23.801 1.248 25 2.786 25h7.428z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.2477b2cb.svg";
export { ForwardRef as ReactComponent };